import { mapEnumToOptions } from '@abp/ng.core';

export enum EvaluationType {
  AreaSpecific = 0,
  Calibration = 1,
  General = 2,
  Autoevaluation = 3,
}

export const evaluationTypeOptions = mapEnumToOptions(EvaluationType);
